export const theme = {
  colors: {},
  fonts: {
    family: {
      default: "'Quicksand', sans-serif",
    },
    sizes: {},
  },
};
